// extracted by mini-css-extract-plugin
export var askAiIcon = "_mh-9";
export var container = "_mh-0";
export var groupSeparator = "_mh-a";
export var highlight = "_mh-4";
export var resultIcon = "_mh-5";
export var resultItem = "_mh-7";
export var resultSubtitle = "_mh-3";
export var resultTitle = "_mh-2";
export var resultsList = "_mh-1";
export var searchGroup = "_mh-6";
export var selected = "_mh-8";